import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, DropdownButton, MenuItem } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import Card from '../common/components/Card';
import queryString from 'query-string';
import MapComponent from '../common/components/MapComponent';

class Center extends Component {
	constructor(props) {
		super(props);

		this.handleCityChange = this.handleCityChange.bind(this);
		this.handleMarkerClick = this.handleMarkerClick.bind(this);
		this.handleCenterSelect = this.handleCenterSelect.bind(this);
		this.renderCenter = this.renderCenter.bind(this);
		this.renderInfoWindow = this.renderInfoWindow.bind(this);
		this.state = {
			selectedCity: null,
			activeMarkerKey: null
		};
	}

	componentDidMount() {
		const { centers, parent, queryParams: { reset } } = this.props;
		if (parent.id > 0 && parent.centerId > 0 && centers.some(x => x.id === parent.centerId) && reset !== 'true') {
			// go directly to parent's selected center if parent is logged in
			this.handleCenterSelect(parent.centerId)
		}
	}

	componentWillReceiveProps(nextProps) {
		if ((this.props.parent.id === 0 || !this.props.centers.some(x => x.id === parent.centerId)) &&
			nextProps.parent.id > 0 && nextProps.parent.centerId > 0 && nextProps.centers.some(x => x.id === nextProps.parent.centerId) && nextProps.queryParams.reset !== 'true') {
			// go directly to parent's selected center if parent is logged in
			this.handleCenterSelect(nextProps.parent.centerId);
		}

		if (this.props.cities.length === 0 && nextProps.cities.length === 1) {
			this.setState({ selectedCity: nextProps.cities[0] });
		}
	}

	handleCityChange(city) {
		this.setState({
			selectedCity: city
		});
	}

	handleMarkerClick(center) {
		this.setState({ activeMarkerKey: center.id });
		this.handleCityChange(center.city);
	}

	handleCenterSelect(centerId) {
		const { referrer } = this.props;

		this.props.history.push({
			pathname: referrer,
			search: queryString.stringify({ ...this.props.queryParams, centerId })
		});
	}

	renderCenter(center, style) {
		const { t } = this.props;

		return <Card key={center.id} title={center.name} onClick={() => this.handleCenterSelect(center.id)} style={{ cursor: 'pointer', ...style }}>
			<div>{center.address}</div>
			<div>{center.phoneNumber ? center.phoneNumber : (center.mobilePhone ? center.mobilePhone : '')}</div>
			<div style={{ marginTop: '10px', float: 'right' }}><a onClick={() => this.handleCenterSelect(center.id)} className='btn btn-primary btn-xss leaflet-button'>{t('FO_Center_Program')}  <i className='fa fa-arrow-circle-right' /></a></div>
		</Card>
	}

	renderInfoWindow(center) {
		return <div onCloseClick={() => this.setState({ activeMarkerKey: null })}>{this.renderCenter(center, { marginBottom: 0, boxShadow: 'none' })}</div>
	}

	render() {
		const { cities, centers, franchisor, t } = this.props;

		const cityCenters = this.state.selectedCity ? centers.filter(c => c.city === this.state.selectedCity) : [];

		const innerHeight = window.innerHeight;
		const showScroll = cityCenters.length > 2;

		const centersList = cityCenters.map(c => this.renderCenter(c, { marginBottom: 15, marginRight: showScroll ? 5 : 0 }));

		return (
			<div>
				<div className='steps_title' style={{ marginBottom: 0 }}>{t('FO_Public_Center_Title')}</div>

				<Row>
					<Col sm={6} md={4}>
						<div className='timetable-search block' style={{ marginBottom: 15 }}>
							<DropdownButton id='searchCity' onSelect={key => {
								this.handleCityChange(key);
								this.setState({
									activeMarkerKey: null
								})
							}}
								className='btn-block'
								bsStyle={this.state.selectedCity ? 'primary' : 'default'}
								title={this.state.selectedCity && this.props.centers.find(c => c.city === this.state.selectedCity) != undefined ? this.state.selectedCity : t('FO_TimetableSearch_City')}>
								{cities && cities.sort().map(city => <MenuItem key={city} eventKey={city} >{city}</MenuItem>)}
							</DropdownButton>
						</div>
						<div style={{
							overflowY: showScroll ? 'scroll' : '',
							height: showScroll ? innerHeight - 260 : 'auto',
							marginBottom: '15px'
						}}>
							{centersList}
						</div>
					</Col>

					{centers.length > 0 && franchisor.mapCenterLatitude && franchisor.mapCenterLongitude && <Col sm={6} md={8}>
						<MapComponent
							height={innerHeight - 200}
							markers={centers.filter(c => c.latitude && c.longitude)}
							latitude={franchisor.mapCenterLatitude}
							longitude={franchisor.mapCenterLongitude}
							defaultZoom={franchisor.mapZoom}
							onMarkerClick={this.handleMarkerClick}
							activeMarkerKey={this.state.activeMarkerKey}
							onMapClick={() => this.setState({ activeMarkerKey: null })}
							infoWindow={this.renderInfoWindow}
						/>
					</Col >}


				</Row>
			</div >
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const { entities: { centers }, configuration: { franchisor }, parent } = state;
	const queryParams = queryString.parse(ownProps.location.search);

	const referrer = (ownProps.location.state && ownProps.location.state.referrer) || queryParams.referrer || '/public/timetable';

	const lessonType = queryParams.lessonType;
	let availableCenters = Object.values(centers).filter(c => !c.hidden && (lessonType !== 'trial' || c.isTrialLesson));

	if (referrer && referrer.includes('workshops')) {
		availableCenters = availableCenters.filter(x => x.isWorkshops);
	}

	return {
		referrer,
		centers: availableCenters.sort((a, b) => a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1),
		cities: [...new Set(Object.values(availableCenters).map(center => center.city))],	// distinct list of cities with centers,
		franchisor,
		parent,
		queryParams
	};
};

export default connect(mapStateToProps, {})(withTranslation()(Center));
